export default __webpack_public_path__ + "static/media/944.992e9054.svg";